import React, { useEffect, useState } from "react";
import ReactApexCharts from "react-apexcharts";

const StackedBar = (props) => {
  const [chartInit, setChartInit] = useState();
  const { data, viewStatus, type, colors,testControlChecked } = props;
  useEffect(() => {
    setChartInit({
      series: [
        {
          name: viewStatus !== "purchaseBehavior" ? "Benchmark" : "Pre",
          data: [!testControlChecked ? data?.controlPre ? data?.controlPre : data?.benchmark:null],
        },
        {
          name: data.topDataPoint,
          data: [ data?.controlPost ? data?.controlPost : data?.testDuringValue],
        },
      ],
      options: {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: {
            show: false,
          },
          sparkline: {
            enabled: true,
          },
        },
        grid: {
          show: false,
        },
        colors: colors ? colors : [],
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        xaxis: {
          show: false,
          labels: {
            // show: false,
            style: {
              colors: ["#ffffff"],
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          show: false,
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        tooltip: {
          fixed: {
            enabled: true,
            position: "bottomLeft", // topRight, topLeft, bottomRight, bottomLeft
            // offsetY: 30,
            // offsetX: 60,
          },

          x: {
            enabled: false,
            show: false,
          },
          y: {
            formatter: (value) => {
              let val;
              if (type !== "pct") {
                val = value;
              } else {
                val = value + "%";
              }
              return val;
            },
          },
        },
      },
    });
  }, [colors,data.benchmark,data.controlPost,data.controlPre,data.testDuringValue,data.topDataPoint,testControlChecked,type,viewStatus]);

  return (
    <React.Fragment>
      {chartInit && (
        <>
          <ReactApexCharts
            options={chartInit.options}
            series={chartInit.series}
            type="bar"
            height={10}
          />
        </>
      )}
    </React.Fragment>
  );
};
export default StackedBar;
